import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { FormControlService } from "../form-control.service";
import { ControlValueAccessorImpl } from "../ng-material-impl/control-value-accessor.impl";
import createControlValueAccessorProvider from "../utils/create-control-value-accessor-provider";
import { TextFormControlService } from "./text-form-control.service";




@Component({
  selector: 'ss-text-form-control',
  templateUrl: './text-form-control.component.html',
  styleUrls: ['./text-form-control.component.css'],
  providers: [
    FormControlService,
    TextFormControlService,
    createControlValueAccessorProvider(TextFormControlComponent)
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextFormControlComponent extends ControlValueAccessorImpl<string> implements OnInit, OnDestroy {


  readonly statusObs = this._formControlService.controlStatusObs;
  readonly actionSubject = this._formControlService.actionSubject;
  constructor() {

    super()

  }


  executeActionCallback() {
    this._formControlService.executeActionCallback();
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

    this._destroy.next();
    this._destroy.complete();

  }
}
